import 'whatwg-fetch';

const knowledgebaseDownload = document.getElementById('knowledgebase-download');

function initknowledgebaseDownload() {
	document.addEventListener('DOMContentLoaded', init);

	function init() {
		addEventListeners();

		// Set event for after succesful login
		window.globalAccountsEvents['knowledgebase-login'] = new CustomEvent('knowledgebase-login', {
			detail: {
				run: function() {
					displayConsent();
				}
			}
		});

		// Set event for after successful consent given
		window.globalAccountsEvents['knowledgebase-give-consent'] = new CustomEvent('knowledgebase-give-consent', {
			detail: {
				run: function() {
					giveConsentAndStartDownload(true);
				}
			}
		});
	}

	function addEventListeners() {

	}

	function displayConsent() {
		knowledgebaseDownload.classList.remove('authenticate');
		knowledgebaseDownload.classList.add('consent');
	}

	function giveConsentAndStartDownload(clicked = false) {
		var data = new FormData;

		data.append('action', 'get_knowledgebase_file_consent');
		data.append('_wpnonce', knowledgebaseDownload.dataset.nonce);
		data.append('post_id', parseInt(knowledgebaseDownload.dataset.postid));

		fetch(mainScriptData.ajaxUrl, {
			method: 'POST',
			body: data
		})
		.then(function(response) {
			if ( response.ok ) {
				return response.json();
			}
		})
		.then(function(data) {
			if ( data.success && data.data ) {
				window.location.href = data.data;
			}

			knowledgebaseDownload.classList.remove('consent');
			knowledgebaseDownload.classList.add('download-started');
		})
		.catch(function (error) {
			console.warn(error);
		});
	}
}

if ( knowledgebaseDownload ) {
	initknowledgebaseDownload();
}
